// import { apiSlice } from '../api/apiSlice'
// import 

import { id } from "date-fns/locale";
import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const INBOUND_BASE = "/inbound";
const buildUrl = (endpoint) => INBOUND_BASE + endpoint;

const inboundsApiSlice =  apiSlice.injectEndpoints({
    endpoints: builder => ({
        getInbounds: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: 'Inbounds' }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getInbounds', 'Inbounds')
        }),
        getInboundsToProcess: builder.query({
            query: (args) => ({
                url: buildUrl(``),
                method: 'POST',
                body: args?.body,
                headers: {
                    "from_app":true
                }
            }),
            providesTags: () => [{ type: 'InboundsToProcess' }],
        }),
        getInboundLines: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`/${args.id}/inboundlines?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: (args) => [{ type: 'InboundLines', id: args?.id }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getInboundLines', 'InboundLines')
        }),
        preRegisterInboundLine : builder.mutation({
            query: ({inboundId, inboundLineId}) => ({
                url: buildUrl(`/${inboundId.toString()}/inboundlines/${inboundLineId.toString()}/preregister`),
                method: 'GET',
            }),
            providesTags: (args) => [{ type: 'PreRegisterLineId', id: (args.inboundId.toString() + args.inboundLineId.toString()) }],
            invalidatesTags: (result, error, arg) => [{type: 'Inbounds'}],
        }),
        updateLineAmountFromProcessing : builder.mutation({
            query: ({id, lineId,amountReceived,remark}) => ({
                url: buildUrl(`/${id.toString()}/inboundlines/update/${lineId.toString()}`),
                method: 'POST',
                body: {
                    amountReceived,
                    remark: remark ?? ""
                }
            }),
        }),
        registerCountInboundLine : builder.mutation({
            query: (body) => ({
                url: buildUrl(`/inboundlines/register`),
                method: 'POST',
                body
            }),
            providesTags: (args) => [{ type: 'RegisterInboundLine'}],
            invalidatesTags: (result, error, arg) => [{type: 'ProductsSingle'}],
        }),
        getAllInboundLines: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`/inboundlines?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: 'InboundLines' }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getInboundLines', 'InboundLines')
        }),
        getInboundLinesForEdit: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`/${args.id}/inboundlines?page=1&size=100`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: 'InboundLinesForEdit' }],
        }),
        addInboundLines: builder.mutation({
            query: inboundLineInfo => ({
                url: buildUrl(`/${inboundLineInfo.inboundId}/inboundlines/add`),
                method: 'POST',
                body: inboundLineInfo.body,
            }),
            invalidatesTags: (result, error, arg) => [{type: 'InboundLines'}, {type: 'Inbounds'}, { type: `InboundSingle` },{ type: 'InboundLinesForEdit' }, { type: 'StockForecast' }],
        }),
        updateInboundLines: builder.mutation({
            query: inboundLineInfo => ({
                url: buildUrl(`/${inboundLineInfo.inboundId}/inboundlines/update`),
                method: 'POST',
                body: inboundLineInfo.body,
            }),
            invalidatesTags: (result, error, arg) => [{type: 'InboundLines'}, {type: 'Inbounds'}, { type: `InboundSingle` },{ type: 'InboundLinesForEdit' }, { type: 'StockForecast' }],
        }),
        getInbound: builder.query({
            query: (id) => ({
                url: buildUrl(`/${id}`),
                method: 'GET',
            }),
            providesTags: (id) => [{ type: `InboundSingle` }]
        }),
        getInboundToProcess: builder.mutation({
            query: (id) => ({
                url: buildUrl(`/${id}`),
                method: 'GET',
                headers: {
                    "from_app":true
                }
            }),
            providesTags: (id) => [{ type: `InboundSingleToProcess` }]
        }),
        getInboundByBarcodeToProcess: builder.mutation({
            query: (barcode) => ({
                url: buildUrl(`/barcode/${barcode}`),
                method: 'GET',
                headers: {
                    "from_app":true
                }
            }),
            providesTags: () => [{ type: 'InboundsToProcess' }],
        }),
        addInbound: builder.mutation({
            query: inboundInfo => ({
                url: buildUrl(`/add`),
                method: 'POST',
                body: inboundInfo,
            }),
            // The purchase advice nets out open inbounds, so a new one changes every forecast row.
            invalidatesTags: (result, error, arg) => [{type: 'Inbounds'}, { type: 'StockForecast' }],
        }),
        // The purchase order mail for an inbound that is not saved yet, built from the add-inbound data.
        previewInboundSupplierMail: builder.mutation({
            query: inboundInfo => ({
                url: buildUrl(`/supplier-mail/preview`),
                method: 'POST',
                body: inboundInfo,
            }),
        }),
        getInboundSupplierMail: builder.query({
            query: ({ id, supplierId }) => ({
                url: buildUrl(`/${id}/supplier-mail?supplierId=${supplierId}`),
                method: 'GET',
            }),
        }),
        // Sending makes the chosen supplier the inbound's supplier.
        sendInboundSupplierMail: builder.mutation({
            query: ({ id, supplierId, subject, html }) => ({
                url: buildUrl(`/${id}/supplier-mail`),
                method: 'POST',
                body: { supplierId, subject, html },
            }),
            invalidatesTags: [{ type: 'Inbounds' }, { type: 'InboundSingle' }],
        }),
        updateInbound: builder.mutation({
            query: inboundInfo => ({
                url: buildUrl(`/${inboundInfo.id}`),
                method: 'PUT',
                body: inboundInfo,
            }),
            invalidatesTags: (result, error, arg) => [{type: 'Inbounds' }, { type: `InboundSingle` }],
        }),
        activateInbound: builder.mutation({
            query: id => ({
                url: buildUrl(`/${id}/activate`),
                method: 'PUT',
            }),
            invalidatesTags: (result, error, arg) => [{type: 'Inbounds' }, { type: `InboundSingle` }, { type: 'StockForecast' }],
        }),
        completeInbound: builder.mutation({
            // Accepts a bare id, or {id, forceComplete} to accept the shortages and close everything
            query: params => {
                const { id, forceComplete } = typeof params === 'object' ? params : { id: params };
                return {
                    url: buildUrl(`/${id}/complete`),
                    method: 'PUT',
                    body: { forceComplete: forceComplete ?? false },
                };
            },
            invalidatesTags: (result, error, arg) => [{type: 'Inbounds' }, { type: `InboundSingle` }, { type: 'InboundLines' }, { type: 'StockForecast' }],
        }),
        deleteInbound: builder.mutation({
            query: id => ({
                url: buildUrl(`/${id}`),
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, arg) => [{type: 'Inbounds' }, { type: `InboundSingle` }, { type: 'StockForecast' }],
        }),
        getInboundShipments: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`/${args.id}/shipments?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: (args) => [{ type: 'InboundShipments', id: args?.id }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getInboundShipments', 'InboundShipments')
        }),
        deleteInboundShipment: builder.mutation({
            query: args => ({
                url: buildUrl(`/${args.inboundId}/shipments/${args.id}`),
                method: 'DELETE'
            }),
            invalidatesTags: (result, error, arg) => [{type: 'InboundShipments'}],
        }),
        addInboundShipments: builder.mutation({
            query: inboundShipmentsInfo => ({
                url: buildUrl(`/${inboundShipmentsInfo.inboundId}/shipments/add`),
                method: 'POST',
                body: inboundShipmentsInfo.body,
            }),
            invalidatesTags: (result, error, arg) => [{type: 'InboundShipments'}],
        }),
        updateInboundShipment: builder.mutation({
            query: inboundShipmentsInfo => ({
                url: buildUrl(`/${inboundShipmentsInfo.inboundId}/shipments/${inboundShipmentsInfo.id}`),
                method: 'PUT',
                body: inboundShipmentsInfo.body,
            }),
            invalidatesTags: (result, error, arg) => [{type: 'InboundShipments'}],
        }),
        getDashboardInboundTotals: builder.query({
            query: (body) => ({
                url: buildUrl(`/dashboard/totals`),
                method: 'POST',
                body
            }),
            
        }),
        getDashboardInboundChart: builder.query({
            query: (body) => ({
                url: buildUrl(`/dashboard/chart`),
                method: 'POST',
                body
            }),
            
        }),
        getDaytotals: builder.query({
            query: () => ({
                url: buildUrl(`/daytotals`),
                method: 'GET'
            }),
        }),
        receiveSerialNumber: builder.mutation({
            query: body => {
                const url = buildUrl(`/${body.id}/serialnumbers/received/${body.lineId}`);
                console.log(url);
                return {
                    url,
                    method: "PUT",
                    body,
                };
            }
        }),
        exportInbounds: builder.mutation({
            query: (body) => ({
                url: buildUrl(`/export`),
                method: 'POST',
                body: body,
                responseHandler: async (response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }

                    const contentType = response.headers.get('content-type');

                    // Check if response is JSON (status 202 - processing or 200 with blobUrl)
                    if (contentType && contentType.includes('application/json')) {
                        const jsonData = await response.json();

                        // If immediate download is ready (status 200 with blobUrl)
                        if (jsonData.blobUrl) {
                            // For storage URLs or signed URLs, just trigger direct download
                            // No need to fetch again - the URL is already accessible
                            const a = document.createElement('a');
                            a.href = jsonData.blobUrl;
                            a.download = jsonData.fileName || `orders_export_${new Date().toISOString().split('T')[0]}.xlsx`;
                            a.target = '_blank'; // Open in new tab as fallback
                            document.body.appendChild(a);
                            a.click();
                            a.remove();

                            return { data: { success: true, message: jsonData.message, immediate: true } };
                        }

                        // Background processing (status 202)
                        return { data: { success: true, processing: true, message: jsonData.message, exportId: jsonData.exportId } };
                    }

                    // Legacy support: Direct blob response (for backwards compatibility)
                    const blob = await response.blob();

                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `inslag_export_${new Date().toISOString().split('T')[0]}.xlsx`;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);

                    return { data: { success: true, immediate: true } };
                },
            }),
        }),
        exportInboundLines: builder.mutation({
            query: (body) => ({
                url: buildUrl(`/inboundlines/export`),
                method: 'POST',
                body: body,
                responseHandler: async (response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }

                    const contentType = response.headers.get('content-type');

                    // Check if response is JSON (status 202 - processing or 200 with blobUrl)
                    if (contentType && contentType.includes('application/json')) {
                        const jsonData = await response.json();

                        // If immediate download is ready (status 200 with blobUrl)
                        if (jsonData.blobUrl) {
                            // For storage URLs or signed URLs, just trigger direct download
                            // No need to fetch again - the URL is already accessible
                            const a = document.createElement('a');
                            a.href = jsonData.blobUrl;
                            a.download = jsonData.fileName || `inslagregels_export_${new Date().toISOString().split('T')[0]}.xlsx`;
                            a.target = '_blank'; // Open in new tab as fallback
                            document.body.appendChild(a);
                            a.click();
                            a.remove();

                            return { data: { success: true, message: jsonData.message, immediate: true } };
                        }

                        // Background processing (status 202)
                        return { data: { success: true, processing: true, message: jsonData.message, exportId: jsonData.exportId } };
                    }

                    // Legacy support: Direct blob response (for backwards compatibility)
                    const blob = await response.blob();

                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `orders_export_${new Date().toISOString().split('T')[0]}.xlsx`;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);

                    return { data: { success: true, immediate: true } };
                },
            }),
        }),
        getInboundPickingSlipPDF: builder.mutation({
            query: body => ({
                url: buildUrl(`/${body.inboundId}/pickingslip`),
                method: 'POST',
                body: body,
                responseHandler: async (response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    // const blob = await response.blob();
                    const blob = new Blob([await response.blob()], { type: 'application/pdf' });
                    const url = URL.createObjectURL(blob);
                    return {data: url};
                },
            }),
        }),
        getInboundPhotos: builder.query({
            query: (inboundId) => ({
                url: buildUrl(`/${inboundId}/photos`),
                method: 'GET',
            }),
            providesTags: (result, error, inboundId) => [
                { type: 'InboundPhotos', id: `${inboundId}` }
            ],
        }),
        getInboundLinePhotos: builder.query({
            query: ({inboundId, inboundLineId}) => ({
                url: buildUrl(`/${inboundId}/inboundlines/${inboundLineId}/photos`),
                method: 'GET',
            }),
            providesTags: (result, error, {inboundId, inboundLineId}) => [
                { type: 'InboundLinePhotos', id: `${inboundId}-${inboundLineId}` }
            ],
        }),
        uploadInboundLinePhoto: builder.mutation({
            query: ({inboundId, inboundLineId, file}) => {
                const formData = new FormData();
                formData.append('file', file);
                return {
                    url: buildUrl(`/${inboundId}/inboundlines/${inboundLineId}/photos`),
                    method: 'POST',
                    body: formData,
                };
            },
            invalidatesTags: (result, error, {inboundId, inboundLineId}) => [
                { type: 'InboundLinePhotos', id: `${inboundId}-${inboundLineId}` },
                { type: 'InboundPhotos', id: `${inboundId}` }
            ],
        }),
        deleteInboundLinePhoto: builder.mutation({
            query: ({inboundId, inboundLineId, photoId}) => ({
                url: buildUrl(`/${inboundId}/inboundlines/${inboundLineId}/photos/${photoId}`),
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, {inboundId, inboundLineId}) => [
                { type: 'InboundLinePhotos', id: `${inboundId}-${inboundLineId}` },
                { type: 'InboundPhotos', id: `${inboundId}` }
            ],
        }),
    })
});

export const {
    useGetInboundsQuery,
    useGetInboundLinesQuery,
    useGetAllInboundLinesQuery,
    useAddInboundLinesMutation,
    useUpdateInboundLinesMutation,
    useGetInboundQuery,
    useAddInboundMutation,
    useUpdateInboundMutation,
    useActivateInboundMutation,
    useCompleteInboundMutation,
    useDeleteInboundMutation,
    useGetInboundShipmentsQuery,
    useDeleteInboundShipmentMutation,
    useAddInboundShipmentsMutation,
    useUpdateInboundShipmentMutation,
    useGetDashboardInboundChartQuery,
    useGetDashboardInboundTotalsQuery,
    useGetInboundsToProcessQuery,
    useGetInboundToProcessMutation,
    useGetInboundByBarcodeToProcessMutation,
    usePreRegisterInboundLineMutation,
    useRegisterCountInboundLineMutation,
    useGetDaytotalsQuery,
    useGetInboundLinesForEditQuery,
    useUpdateLineAmountFromProcessingMutation,
    useReceiveSerialNumberMutation,
    useExportInboundLinesMutation,
    useExportInboundsMutation,
    useGetInboundPickingSlipPDFMutation,
    useGetInboundPhotosQuery,
    useGetInboundLinePhotosQuery,
    useUploadInboundLinePhotoMutation,
    useDeleteInboundLinePhotoMutation,
    usePreviewInboundSupplierMailMutation,
    useGetInboundSupplierMailQuery,
    useSendInboundSupplierMailMutation
  } = inboundsApiSlice;
